<template>
  <div></div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      VUE_APP_ID,
    };
  },
  created() {},
};
</script>

<style></style>
